import { render } from "./email-verification.vue?vue&type=template&id=b8b34476&scoped=true"
import script from "./email-verification.vue?vue&type=script&lang=js"
export * from "./email-verification.vue?vue&type=script&lang=js"

import "./email-verification.vue?vue&type=style&index=0&id=b8b34476&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b34476"]])

export default __exports__